import "../../shimmer.css";
const CompanyInfoShimmer = () => {
  return (
    <div className="w-full space-y-3">
      <div className="animate-pulse-gradient w-[180px] h-3 rounded-full"></div>
      <div className="w-full p-5 bg-white rounded-2xl border border-gray-200/70 shadow-[0_2px_10px_rgba(61,89,132,0.08)] flex flex-col sm:flex-row gap-4 sm:gap-5 items-center sm:justify-between">
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-5">
          <div className="w-[88px] h-[88px] rounded-full overflow-hidden animate-pulse-gradient shrink-0"></div>
          <div className="flex flex-col gap-3 items-center sm:items-start">
            <div className="w-[150px] md:w-[250px] h-3 rounded-full animate-pulse-gradient"></div>
            <div className="w-[100px] md:w-[200px] h-3 rounded-full animate-pulse-gradient"></div>
          </div>
        </div>
        <div className="w-full sm:w-[160px] h-11 rounded-full animate-pulse-gradient"></div>
      </div>
    </div>
  );
};

export default CompanyInfoShimmer;
